import { render, staticRenderFns } from "./editLabel.vue?vue&type=template&id=0c8b99fc&scoped=true"
import script from "./editLabel.vue?vue&type=script&lang=js"
export * from "./editLabel.vue?vue&type=script&lang=js"
import style0 from "./editLabel.vue?vue&type=style&index=0&id=0c8b99fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b99fc",
  null
  
)

export default component.exports